__webpack_require__.p = "/pokopedia-favorites/";